import * as React from "react";
// import { pure } from 'recompose';
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import * as i18next from "i18next";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { isOpen, toggleModal, onAllReinitialization } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isOpen}>
      <StyledComponent.ModalContainerInsider
        isVisible={isOpen}
        style={{
          overflow: "visible",
          width: "660px",
          backgroundColor: "unset",
        }}
      >
        <div className="modal-segmentation">
          <div className="title-sequence-infos">
            {i18next.t("reinitialiser")}
            <span onClick={toggleModal} />
          </div>
          <div className="sequence-content">
            <p>
              {" "}
              {i18next.t(
                "etes-vous sur de vouloir reinitaliser la segmentation"
              )}
            </p>
            <p> {i18next.t("de tous les masques de cette camera")}</p>
          </div>
          <div className="modalBtn">
            <span className="borderGradian" onClick={toggleModal}>
              <span
                className="btnSecondary "
                style={{ backgroundColor: "white", overflow: "visible" }}
              >
                <span className="textGradianlarge">{i18next.t("annuler")}</span>
              </span>
            </span>
            <span
              className="btnPrimary "
              style={{ overflow: "visible", marginLeft: "5px" }}
              onClick={onAllReinitialization}
            >
              {i18next.t("oui")}
            </span>
          </div>
        </div>
      </StyledComponent.ModalContainerInsider>
    </StyledComponent.ModalContainer>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onAllReinitialization?: any;
  toggleModal?: any;
  isOpen?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/modal/initialization/component.tsx